// Imports
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tippy from '@tippyjs/react';
import styled from 'styled-components/macro';
import tippyProps from '../../../../../shareables/foundation/front-end/utils/tippy-props';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';


// Styled component
const Wrapper = styled.span`
	white-space: nowrap;
	.svg-inline--fa {
		padding-left: 0.2rem;
		color: hsl(206, 45%, 64%);
	}
`;


// Define the accepted props
interface Props {
	tooltipText: string;
}


// Function component
const InfoIconTooltip: React.FC<Props> = ({ tooltipText }) => (
	<Tippy content={tooltipText} {...tippyProps}>
		<Wrapper aria-label={tooltipText}>
			&#8288;
			<FontAwesomeIcon icon={faCircleInfo} />
		</Wrapper>
	</Tippy>
);

export default InfoIconTooltip;
